//filter/htmlDecode.js

function removeHtmlTag(value) {
	return value.replace(/(<([^>]+)>)/gi, '');
}

export default removeHtmlTag;
